import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { SdgsLensEmptyState } from '@upright/ui/common/upright/core/impact-lenses/sdg/empty-state';
import { SdgDivBoxes } from '@upright/ui/common/upright/core/impact-lenses/sdg/info-boxes/div-boxes';
import { SdgInfoBoxes } from '@upright/ui/common/upright/core/impact-lenses/sdg/info-boxes/sdg-info-boxes';
import { sdgLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/sdg/selection-state';
import { sdgLensTexts } from '@upright/ui/common/upright/core/impact-lenses/sdg/texts';
import { SdgLensData, SdgLensOptions } from '@upright/ui/common/upright/core/impact-lenses/sdg/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';
import { SdgLensBottomArea } from './bottom-area';

export const sdgLens: ImpactLens<ImpactLensType.SDGS, SdgLensData, SdgLensOptions> = {
  type: ImpactLensType.SDGS,
  ImpactDataComponent: { component: () => <></> },
  infoBoxes: {
    SvgComponent: SdgInfoBoxes,
    DivComponent: SdgDivBoxes,
  },
  AggregateResultArea: SdgLensBottomArea,
  boxesAreaWidth: (_fullWidth: number) => 0,
  maxDataAreaWidth: (_fullWidth: number) => 600,
  boxMode: (_fullWidth: number) => {
    return LensBoxMode.SIDE; // actually no boxes (TODO: add enum constant for that)
  },
  aggregateResultAreaHeight: (_fullWidth: number) => {
    return 65;
  },
  centerAreaWidth: (fullWidth: number) => {
    if (fullWidth < 500) {
      return 140;
    }
    return undefined;
  },
  EmptyState: SdgsLensEmptyState,
  ...sdgLensSelectionState,
  ...sdgLensTexts,
};
